import React from "react";
import { Button } from "@mui/material";

const Tabs = ({ selectedTab, handleTabClick, countByStatus }) => {
  return (
    <div style={styles.container}>
      {["novi", "aktivni", "zavrseni", "svi"].map((tab, idx) => (
        <Button
          key={tab}
          onClick={() => handleTabClick(tab)}
          style={{
            ...(selectedTab === tab ? styles.activeStyle : styles.baseStyle),
            ...(idx === 0 && { borderLeft: "none" }),
            ...(idx === 3 && { borderRight: "none" }),
          }}
        >
          {tab.charAt(0).toUpperCase() + tab.slice(1)} ({countByStatus[tab]})
        </Button>
      ))}
    </div>
  );
};

export default Tabs;

const sharedStyle = {
  height: "40px",
  fontWeight: 600,
  textTransform: "none",
  borderLeft: "1px solid black",
  padding: "0 16px",
  borderRadius: 0,
};

const styles = {
  container: {
    display: "inline-flex",
    marginBottom: "20px",
    borderRadius: "10px",
    overflow: "hidden",
    border: "1px solid black",
  },
  baseStyle: {
    ...sharedStyle,
    backgroundColor: "#fff",
    color: "#000",
  },
  activeStyle: {
    ...sharedStyle,
    backgroundColor: "#000",
    color: "#fff",
  },
};
